class CountryPickerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CountryPickerDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setCountryPickerButtonAccessibility();
    window.openedDrawers = window.openedDrawers || new Set();
  }

  setCountryPickerButtonAccessibility() {
    const pickerLinks = document.querySelectorAll('[data-country-picker-toggle]')

    for (const pickerLink of pickerLinks) {
      if (!pickerLink) continue
      pickerLink.setAttribute('role', 'button');
      pickerLink.setAttribute('aria-haspopup', 'dialog');
      pickerLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(pickerLink)
      });
      pickerLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(pickerLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('CountryPickerDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    window.openedDrawers.add('country-picker');
  }

  close() {
    window.openedDrawers.delete('country-picker');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    window.openedDrawers.size === 0 && document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('country-picker-drawer', CountryPickerDrawer);
